export default __webpack_public_path__ + "static/media/rg.a356f6e4.png";